import { UserMenuLayout } from "@portal/components/layout/UserMenuLayout";
import { UserMenuOption } from "@portal/components/ui/UserMenuOption";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import {
	HiOutlineBuildingOffice2,
	HiOutlineFlag,
	HiOutlineHashtag,
	HiOutlineTag,
} from "react-icons/hi2";
import { NavLink } from "react-router-dom";

export const AdminUserMenu = () => {
	const { user } = useAuthenticatedUser();
	return (
		<UserMenuLayout
			user={user}
			logoutOptions={{
				openUrl: (url: string) => {
					window.open(url, "_self");
				},
			}}
		>
			<NavLink to="/agencies">
				<UserMenuOption label="Manage Agencies" Icon={HiOutlineBuildingOffice2} />
			</NavLink>
			<NavLink to="/entity-tags">
				<UserMenuOption label="Manage Entity Tags" Icon={HiOutlineTag} />
			</NavLink>
			<NavLink to="/bond-numbers">
				<UserMenuOption label="Manage Bond Numbers" Icon={HiOutlineHashtag} />
			</NavLink>
			{user.type === "admin" && user.roles.includes("developer") && (
				<NavLink to="/feature-flags">
					<UserMenuOption label="Manage Feature Flags" Icon={HiOutlineFlag} />
				</NavLink>
			)}
		</UserMenuLayout>
	);
};
